import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  label: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium
  },

  container: {
    margin: 0,
    backgroundColor: 'transparent',
    '& > .MuiAccordionSummary-root': {
      margin: '4px 0 8px'
    }
  },
  summary: {
    minHeight: '48px',
    '& .MuiAccordionSummary-content': {
      justifyContent: 'left',
      gap: '16px'
    },
    '& .MuiTypography-body2': {
      paddingBottom: 0
    }
  },
  arrowIcon: {
    fontSize: 'medium'
  },
  details: {
    padding: '8px',
    backgroundColor: 'transparent',
    width: '100%',
    maxHeight: '120px',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '8px',
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`,
    borderRadius: '4px'
  }
});
